import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import StoreController, { AdverHotelType } from '../../controller/StoreController';

const DashboardAddHotel = ({ defaultStoreInfo }: any) => {
  const [notAdvertisingList, setNotAdvertisingList] = useState<AdverHotelType[]>([]);
  const [advertisingList, setAdvertisingList] = useState<AdverHotelType[]>([]);
  const [adHotelCount, setHotelCount] = useState<number>(0);
  const [adDeviceCount, setAdDeviceCount] = useState<number>(0);

  const getHotelStore = async () => {
    const oParams = {
      store_id: defaultStoreInfo.value,
    };
    const oResponse = await StoreController.getHotelStore(oParams);
    if (oResponse && oResponse.data) {
      const oRes = oResponse.data;
      if (oRes.data) {
        let deviceCount = 0;
        let listTemp: AdverHotelType[] = [];
        let notAdlistTemp: AdverHotelType[] = [];

        oRes.data.map((item: AdverHotelType) => {
          if (item.is_ad) {
            listTemp.push(item);
            deviceCount += item.room_cnt;
          } else if (!item.is_ad && item.confirm_type !== undefined) {
            listTemp.push(item);
          } else {
            notAdlistTemp.push(item);
          }
        });
        setAdvertisingList([...listTemp]);
        setNotAdvertisingList([...notAdlistTemp]);
        setHotelCount(listTemp.filter((item: AdverHotelType) => item.is_ad).length);
        setAdDeviceCount(deviceCount);
      }
    }
  };
  useEffect(() => {
    getHotelStore();
  }, [defaultStoreInfo]);

  return (
    <Style>
      <div className="addHotelWrap">
        <div className="addHotelInfo">
          <h2>
            현재 우리 매장은 <strong>{adHotelCount}개</strong>의 호텔,
          </h2>
          <h2>
            총 <strong>{adDeviceCount}개</strong>의 객실에서 광고중입니다.
          </h2>
        </div>
        {notAdvertisingList.length > 0 ? (
          <>
            <div className="notAddHotelListWrap">
              <div className="title">
                사장님 입점 가능한 호텔이 {notAdvertisingList.length}개 있어요!
              </div>
              <div className="listBoxWrap">
                {notAdvertisingList.slice(0, 3).map((data) => (
                  <div className="listBox" key={data.store_id}>
                    <img src={`${process.env.PUBLIC_URL}/img/hotel.png`} alt="hotel" width={40} />
                    <h3>{data.store_name}</h3>
                    <h4>{data.room_cnt}객실</h4>
                    <h4>{data.distance && '매장과의 거리' + data.distance + 'km'}</h4>
                  </div>
                ))}
              </div>
            </div>
            <Link to={'/advertise/status'}>
              <p className="addHotelButton">우리매장 광고 추가 하기</p>
            </Link>
          </>
        ) : (
          <div className="notAdvertisingText">
            <h4>현재는 추가할 수 있는 호텔이 없지만</h4>
            <h4>앞으로 더 많은 호텔이 입점될 예정이에요!</h4>
            <h4>새로운 호텔이 들어오면 가장 먼저 소식 전해드릴게요😊</h4>
          </div>
        )}
      </div>
    </Style>
  );
};

export default DashboardAddHotel;

const Style = styled.div`
  h2 {
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: #000;
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
  }
  h4 {
    font-size: 16px;
    color: #333;
  }
  p {
    font-size: 12px;
    font-weight: 400;
    color: #999;
  }

  .addHotelWrap {
    padding: 16px;
  }
  .notAddHotelListWrap {
    margin: 30px 0;
    border-radius: 4px;
    color: #333;
    font-weight: 600;
  }
  .listBoxWrap {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 12px;
    margin-top: 15px;
  }
  .listBox {
    min-height: 150px;
    flex: 1;
    padding: 10px 0;
    background: #fff;
    border-right: 1px solid #eee;

    h3 {
      margin-bottom: 10px;
    }
    h4 {
      margin-top: 6px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    background-image: linear-gradient(90deg, #d186ff 0%, #8a9dff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  .listBox:last-child {
    border: none;
  }
  .addHotelButton {
    width: 100%;
    background: #333;
    padding: 12px 0 10px 0;
    border-radius: 2px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }
  .addHotelButton:hover {
    background: linear-gradient(90deg, #d186ff 0%, #8a9dff 100%);
  }

  /* notAdvertisingText */
  .notAdvertisingText {
    margin-top: 50px;
    padding: 50px 0;
    text-align: center;
    border: 1px solid #eee;
    border-radius: 5px;

    h4 {
      line-height: 30px;
    }
  }

  @media (max-width: 900px) {
    h2 {
      font-size: 20px;
      line-height: 28px;
    }
    .notAdvertisingText {
      margin-top: 10px;
    }
  }
`;
